var anchor = require("./common/anchor");
var nav = require("./common/nav");
var slider = require("./common/slider");

import 'slick-carousel';
import 'slick/slick.css'
import 'slick/slick-theme.css'
import fancybox from 'fancybox';
import 'fancybox/dist/css/jquery.fancybox';

fancybox($);fancybox

;(function($){

	var winW = $(window).width(), 
		winH = $(window).height();

	var sliderRecipe = [];

	//////////////////////////////////// load
	$(window).on('load',function(){
		init();
		popImage();
		nav;
		slider;
		subMenu();
		itemhide();
		pulldown();
		$(".group").fancybox({});

	});

	/*////////////////////////////////////////// SCROLL */
	$(window).on('scroll',onScroll);
	function onScroll(){
		var winW = $(window).width(), 
			winH = $(window).height();
		
		scrollbtn();
	}

	//////////////////////////////////// Func
	
	function subMenu(){
		$(".gnavList.lists1 .productList").on("click",function(){
			$(".sub",this).fadeToggle();
			if($(this).hasClass("on")){
				$(this).removeClass("on");
				$(".header").css({
					"border-bottom":"8px solid #bbb3d8",
				});
			}else{
				$(this).addClass("on");
				$(".header").css({
					"border-bottom":"1px solid #e5e5e5",
				});
			}
					
		});
		$(".sub li a",this).on("click",function(e){
			e.stopPropagation();　
		});
	}

	function init(){
    //ローディング画面
	    $('#wrap').css('display','none');
	    $('#loading').height(winH).css('display','block');
	    $('#loading').delay(900).fadeOut(800); 
	    $('#loader').delay(900).fadeOut(800);
	    $('#wrap').css('display', 'block');
	  }
	 


	function scrollbtn(){
		var pos = $(window).scrollTop() + winH - 30;
		var footerset = $(".footer").offset().top;

		if(pos > 1500){
			$(".scroll").fadeIn();
		}else{
			$(".scroll").fadeOut();
		}
		if(pos > footerset){
			$(".scroll").addClass("stop");
		}else{
			$(".scroll").removeClass("stop");
		}
	}

	function itemhide(){
		$(".product .more").on("click",function(){
			var hidelist = $(this).prev(".itemCards").children(".itemCard:gt(3)");

			hidelist.fadeToggle();
			hidelist.toggleClass("active")
			console.log(hidelist.css("display"));
			if(hidelist.hasClass("active")){
				$("p",this).html("閉じる");
				$(this).addClass("open");
			}else{
				$("p",this).html("商品をもっと見る");
				$(this).removeClass("open");
			}
		});
	}
			
	function popImage(){
		$(".ex_btn").each(function(){
			var brother = $(this).prev(".itemCardBodyMv").find("img").attr('src');
			$(this).find(".group").attr("href", brother )
		});		
	}

	function pulldown(){
		$(".pulldown").on("click",function(){
			if($(this).hasClass("open")){
				$(this).removeClass("open");
				$(this).nextAll().slideUp();
			}else{
				$(this).addClass("open");
				$(this).nextAll().slideDown();
			}
		});
	}

})(jQuery);